import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import PdAnalytics from '@pagerduty/pd-segment-library';

import config from '../../config/app';
import styles from './styles.module.css';
import NurtureBar from '../NurtureBar';
import { fetchPersonaData } from '../../redux/persona/actions';
import { fetchFeData } from '../../redux/fe-data/actions';
import {
  getUser,
  getAccount,
  isFreemiumAccountState,
  isUserEligibleForNurtureBar,
  userHasValidFeatureGates,
  shouldSeeVariantOnboarding as shouldSeeVariantOnboardingSelector,
} from '../../redux/fe-data/selectors';
import { getSpecificEnvironment } from '../../util/environment';
import FreemiumNurtureBar from '../FreemiumNurtureBar';
import CallToActions from '../CallToActions';
import VariantOnboarding from '../VariantOnboarding';

export class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSegmentReady: false,
    };
  }

  async componentDidMount() {
    await this.props.fetchFeData();
    await this.props.fetchPersonaData();
    await this.initializeSegment();

    const isEligibleRoute = this.isEligibleRoute();

    this.setState({
      isSegmentReady: true,
      isEligibleRoute,
    });
  }

  // Determine if the user on a page where they should see the nurture bar.
  isEligibleRoute = () => {
    let isEligibleRoute = false;

    // Must be a route that is allowed to see nurture
    const url = window.location.href;
    const isNotApartOfUrl = route => url.includes(route) === false;
    isEligibleRoute = config.UNALLOWED_ROUTES.every(isNotApartOfUrl);

    return isEligibleRoute;
  }

  initializeSegment() {
    const isProductionEnv = getSpecificEnvironment() === 'production';
    const writeKey = (
      isProductionEnv
        ? config.SEGMENT_WRITE_KEY.production
        : config.SEGMENT_WRITE_KEY.development
    );
    return new PdAnalytics(writeKey, this.props.user, this.props.account, this.props.user.features);
  }

  render() {
    const { isEligibleRoute, isSegmentReady } = this.state;
    const {
      isEligibleForNurtureBar,
      hasValidFeatureGates,
      isFreemiumAccount,
      personaData,
      shouldSeeVariantOnboarding,
    } = this.props;

    if (isEligibleRoute && personaData.traits && isSegmentReady && hasValidFeatureGates) {
      if (isFreemiumAccount) {
        return (
          <div className={styles.reactNurtureBar}>
            <FreemiumNurtureBar />
          </div>
        );
      }
      if (shouldSeeVariantOnboarding) {
        return (
          <div className="apply-design-system">
            <VariantOnboarding />
          </div>
        );
      }
      // Checks if the user is eligible for the NurtureBar component
      // which covers trial and active account owner and responders
      if (isEligibleForNurtureBar) {
        return (
          <NurtureBar />
        );
      }
      return (
        <CallToActions />
      );
    }
    return null;
  }
}

App.propTypes = {
  fetchPersonaData: PropTypes.func.isRequired,
  fetchFeData: PropTypes.func.isRequired,
  personaData: PropTypes.oneOfType([
    PropTypes.shape({
      traits: PropTypes.shape({})
    }),
    PropTypes.shape({})
  ]).isRequired,
  user: PropTypes.shape({
    role: PropTypes.string,
    features: PropTypes.array,
    toggles: PropTypes.array,
  }).isRequired,
  account: PropTypes.shape({
    state: PropTypes.string,
  }).isRequired,
  isFreemiumAccount: PropTypes.bool.isRequired,
  hasValidFeatureGates: PropTypes.bool,
  isEligibleForNurtureBar: PropTypes.bool,
  shouldSeeVariantOnboarding: PropTypes.bool.isRequired,
};

App.defaultProps = {
  hasValidFeatureGates: false,
  isEligibleForNurtureBar: false,
};

const mapStateToProps = state => ({
  personaData: state.personaData,
  user: getUser(state),
  account: getAccount(state),
  isFreemiumAccount: isFreemiumAccountState(state),
  hasValidFeatureGates: userHasValidFeatureGates(state),
  isEligibleForNurtureBar: isUserEligibleForNurtureBar(state),
  shouldSeeVariantOnboarding: shouldSeeVariantOnboardingSelector(state),
});

const mapActionsToProps = {
  fetchPersonaData,
  fetchFeData,
};
export default connect(mapStateToProps, mapActionsToProps)(App);
